import {ChangeDetectionStrategy, Component, inject, signal,} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {StudentDto, UserDto} from '@api/utisha-backend';
import {UserService} from '../../services/user/user.service';
import {NavigationService} from '../../services/nav/navigation.service';
import {UtIconComponent} from '../../ui/icon/ut-icon.component';

/**
 * Compact credits indicator for the nav action row — a pill-shaped button
 * showing a `coins` icon and the current credit balance. Click navigates to
 * the credit details page. Rendered inside the main nav alongside shop,
 * chat indicator and profile, so it uses the same tokenized chrome as the
 * rest of the action row.
 */
@Component({
  selector: 'app-student-credits',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './student-credits.component.html',
  styleUrls: ['./student-credits.component.scss'],
  imports: [TranslatePipe, UtIconComponent],
})
export class StudentCreditsComponent {
  private readonly userService = inject(UserService);
  public readonly nav = inject(NavigationService);

  protected readonly user = signal<StudentDto | undefined>(undefined);

  constructor() {
    this.userService
      .getUserObservable()
      .subscribe({ next: (user?: UserDto) => this.user.set(user as StudentDto | undefined) });
  }

  protected creditsLabel(): string {
    return String(this.user()?.credits ?? 0);
  }
}
